<template>
    <div class="my-orders">
        <h3 class="mb-3">TOS</h3>

        <div class='form-group'>
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                <div>
                    <div class="btn-group mb-3">
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.bold() }" @click="commands.bold">
                            <font-awesome-icon :icon="['far', 'bold']" />
                        </button>
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.italic() }" @click="commands.italic">
                            <font-awesome-icon :icon="['far', 'italic']" />
                        </button>
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.underline() }" @click="commands.underline">
                            <font-awesome-icon :icon="['far', 'underline']" />
                        </button>
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.strike() }" @click="commands.strike">
                            <font-awesome-icon :icon="['far', 'strikethrough']" />
                        </button>
                    </div>
                    <div class="btn-group mb-3 ml-2">
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.bullet_list() }" @click="commands.bullet_list">
                            <font-awesome-icon :icon="['far', 'list-ul']" />
                        </button>
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.ordered_list() }" @click="commands.ordered_list">
                            <font-awesome-icon :icon="['far', 'list-ol']" />
                        </button>
                    </div>
                    <div class="btn-group mb-3 ml-2">
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.heading({ level: 1 }) }" @click="commands.heading({ level: 1 })">
                            <font-awesome-icon :icon="['far', 'h1']" />
                        </button>
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 2 })">
                            <font-awesome-icon :icon="['far', 'h2']" />
                        </button>
                        <button class="btn btn-sm btn-light" :class="{ 'active': isActive.heading({ level: 3 }) }" @click="commands.heading({ level: 3 })">
                            <font-awesome-icon :icon="['far', 'h3']" />
                        </button>
                    </div>
                    <div class="btn-group mb-3 ml-2">
                        <button class="btn btn-sm btn-light" @click="showImagePrompt(commands.image)">
                            <font-awesome-icon :icon="['far', 'images']" />
                        </button>
                    </div>
                </div>
            </editor-menu-bar>

            <editor-content :editor="editor" class="border rounded p-3 editor-body" />
        </div>
        <div class='form-group'>
            <button class='btn btn-primary float-right' @click='save'>Save</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>



import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
    Bold,
    Italic,
    Underline,
    Image,
    OrderedList,
    BulletList,
    ListItem,
    Strike,
    Link,
    Heading,
    HorizontalRule
} from 'tiptap-extensions'

export default {
    data: () => ({
        busy: false,
        editor: null,
    }),
    computed: {
    },
    components: {
        EditorContent,
        EditorMenuBar,
    },
    methods: {
        save() {
            this.busy = true
            this.$http({
                'url': 'dashboard/affiliate/terms/save',
                'method': 'POST',
                data: {
                    terms: this.editor.getHTML()
                }
            }).then((response) => {
                this.busy = false
                this.$swal({
                    toast: true,
                    html: 'Changes saved',
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })
            }).catch((error) => {
                this.busy = false
                this.$swal({
                    toast: true,
                    html: 'Whoops, something went wrong.',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })               
            })           
        },
        getTOS () {
            this.busy = true
            this.$http({
                'url': 'dashboard/affiliate/terms',
                'method': 'GET',
            }).then((response) => {
                this.busy = false
                this.editor.setContent(response.data.result.terms)
            }).catch((error) => {
                this.busy = false
                this.$swal({
                    toast: true,
                    html: 'Whoops, something went wrong.',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })               
            })
        },
    },
    mounted () {
        this.editor = new Editor({
                content: '',
                extensions: [
                    new Bold(),
                    new Italic(),
                    new Underline(),
                    new Image(),
                    new BulletList(),
                    new OrderedList(),
                    new Strike(),
                    new Heading({ levels: [1, 2, 3] }),
                    new Link(),
                    new HorizontalRule(),
                    new ListItem(),
                ]
            })
        this.getTOS()
    },
}
</script>
